import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Home, PackageSearch, MessageCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { business } from "../data/siteData";

// PayTR ödeme tamamlandığında iframe'in KENDİSİNİ bu adrese yönlendirir
// (üst pencereyi değil). Sayfa hâlâ iframe içindeyse üst pencereyi aynı
// adrese taşıyarak "kırılır" — kullanıcı PayTR'nin küçük iframe kutusunda
// değil, sitenin tam sayfa onay ekranında kalır.
function useBreakOutOfIframe() {
  const [insideIframe, setInsideIframe] = useState(false);
  useEffect(() => {
    if (window.self !== window.top) {
      setInsideIframe(true);
      window.top.location.href = window.location.href;
    }
  }, []);
  return insideIframe;
}

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const orderNumber = params.get("num") || params.get("order");
  const insideIframe = useBreakOutOfIframe();

  if (insideIframe) return null;

  return (
    <div className="min-h-screen bg-white text-[#222222]">
      <Header />
      <div className="frida-container py-16 flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 rounded-full bg-[#A85C34]/10 flex items-center justify-center mb-6">
          <CheckCircle2 className="w-9 h-9 text-[#A85C34]" />
        </div>
        <h1 className="font-serif text-3xl mb-3">Ödemeniz Alındı!</h1>
        <p className="text-sm text-[#888888] max-w-sm mb-2">
          Teşekkürler, ödemeniz başarıyla tamamlandı. Siparişiniz hazırlanmaya başlanacak.
        </p>
        {orderNumber && (
          <div className="mb-8 px-6 py-4 rounded-2xl bg-[#F8F8F8] border border-[#EAEAEA]">
            <p className="text-xs text-[#888888] mb-1">Sipariş Numaranız</p>
            <p className="font-serif text-2xl text-[#A85C34] font-bold">#{orderNumber}</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#A85C34] hover:bg-[#8B4726] text-white rounded-full font-medium transition-colors">
            <Home className="w-4 h-4" /> Ana Sayfaya Dön
          </Link>
          <Link to="/siparis-takibi" className="inline-flex items-center gap-2 px-7 py-3.5 bg-white border border-[#EAEAEA] hover:border-[#A85C34] text-[#222222] rounded-full font-medium transition-colors">
            <PackageSearch className="w-4 h-4" /> Siparişimi Takip Et
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export function PaymentFailurePage() {
  const [params] = useSearchParams();
  const orderNumber = params.get("num") || params.get("order");
  const insideIframe = useBreakOutOfIframe();

  if (insideIframe) return null;

  return (
    <div className="min-h-screen bg-white text-[#222222]">
      <Header />
      <div className="frida-container py-16 flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 rounded-full bg-rose-500/10 flex items-center justify-center mb-6">
          <XCircle className="w-9 h-9 text-rose-500" />
        </div>
        <h1 className="font-serif text-3xl mb-3">Ödeme Tamamlanamadı</h1>
        <p className="text-sm text-[#888888] max-w-sm mb-2">
          Kart işleminiz onaylanamadı ya da yarıda kaldı. Sipariş numaranız kayıtlı — dilerseniz WhatsApp
          üzerinden bize ulaşıp farklı bir ödeme yöntemiyle devam edebiliriz.
        </p>
        {orderNumber && (
          <div className="mb-8 px-6 py-4 rounded-2xl bg-[#F8F8F8] border border-[#EAEAEA]">
            <p className="text-xs text-[#888888] mb-1">Sipariş Numaranız</p>
            <p className="font-serif text-2xl text-[#A85C34] font-bold">#{orderNumber}</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href={business.social.whatsapp}
            target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full font-medium transition-colors"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp ile Ulaşın
          </a>
          <Link to="/" className="inline-flex items-center gap-2 px-7 py-3.5 bg-white border border-[#EAEAEA] hover:border-[#A85C34] text-[#222222] rounded-full font-medium transition-colors">
            <Home className="w-4 h-4" /> Ana Sayfaya Dön
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
